(function() { window.GUID_f36141d2_23f2_45f8_bbd2_8e5760518296 = { getGuid: function() { return "f36141d2-23f2-45f8-bbd2-8e5760518296"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var VideoPlayerInternals;
        (function (VideoPlayerInternals) {
            class Chapiter extends VideoPlayerInternals.BaseInternal {
                constructor(player) {
                    super(player);
                    this.video = this.player.video;
                    this.RightPanelList = new ChapiterInternal.RightList(player);
                    this.container = this.player.$Control;
                    this.Chapiters = player.Chapiters;
                    this.chapitersProgressContainer = this.container.find('.progress-chapiters');
                    this.listChapiter = this.container.find(".chapiters .list-chapiters ol");
                    if (this.Chapiters && this.Chapiters.length > 0) {
                        this.setSeekToChapiters();
                        if (!this.player.videoThumbnail.Loaded)
                            this.player.videoThumbnail.onLoaded = () => { this.loadPreviewImages(); };
                        else
                            this.loadPreviewImages();
                    }
                    else
                        this.eventRaiser.ChapitersLoaded(null, { chapiters: null });
                }
                setSeekToChapiters() {
                    for (var i = 0; i < this.Chapiters.length; i++) {
                        this.Chapiters[i].SeekTo = () => { this.SeekToShapiter(i); };
                    }
                }
                loadPreviewImages() {
                    var images = this.listChapiter.find('.img-chapiter-preview');
                    if (images.length > 0) {
                        var next = (i) => {
                            if (images.length > i) {
                                var img = $(images[i]);
                                var index = img.closest("li").data("index");
                                if (index !== undefined && jQuery.isNumeric(index)) {
                                    var chapiter = this.Chapiters[index];
                                    this.player.videoThumbnail.GetImage(chapiter.StartSeconds, (image) => {
                                        img.attr("src", image);
                                        chapiter.ImageDataUrl = image;
                                        next(i + 1);
                                    });
                                }
                            }
                            else
                                this.eventRaiser.ChapitersLoaded(null, { chapiters: this.Chapiters });
                        };
                        next(0);
                    }
                }
                chapiterClicked(e) {
                    var chapiterElement = e.target.tagName == 'li' ? $(e.target) : $(e.target).closest('li');
                    var index = Number(chapiterElement.data("index"));
                    if (this.SeekToShapiter(index)) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
                updateDuration() {
                    this.chapitersProgressContainer.html('');
                    if (this.Chapiters && this.Chapiters.length > 0) {
                        var totalSeconds = this.video.duration;
                        for (var i = 0; i < this.Chapiters.length; i++) {
                            var item = this.Chapiters[i];
                            var percent = ((item.EndSeconds - item.StartSeconds) / totalSeconds) * 100;
                            var element = $('<div></div>');
                            element.attr("data-index", i);
                            element.addClass("progress-chapiter");
                            element.css("width", percent + "%");
                            this.chapitersProgressContainer.append(element);
                        }
                    }
                }
                SeekToShapiter(index) {
                    if (index !== null && this.Chapiters !== null && index < this.Chapiters.length) {
                        var chapiter = this.player.Chapiters[index];
                        this.player.Seek(chapiter.StartSeconds);
                        return true;
                    }
                    return false;
                }
                OnBindEvents() {
                    this.event(this.listChapiter)
                        .offonSelector("click", "li, li *", (e, a) => {
                        this.chapiterClicked(e);
                        this.RightPanelList.Hide();
                    });
                    this.event(this.video)
                        .offon("durationchange", () => { this.updateDuration(); });
                    //this.event(this.chapitersProgressContainer)
                    //    .offonSelector("click", ".progress-chapiter", (e, a) => { this.chapiterClicked(e); });
                }
                ChapiterMenuButtonClick(e) {
                    var event = new ChapiterMenuToggleEventArgs({ chapiterMenuVisible: this.RightPanelList.IsVisible });
                    this.eventRaiser.ChapiterMenuToggle(e, event);
                    if (!event.isPreventDefaultAction)
                        this.RightPanelList.ToggleVisibility();
                }
                OnDispose() {
                }
            }
            VideoPlayerInternals.Chapiter = Chapiter;
            let ChapiterInternal;
            (function (ChapiterInternal) {
                class RightList {
                    constructor(player) {
                        this.player = player;
                        this.container = player.$Control;
                    }
                    ToggleVisibility() {
                        this.container.toggleClass("show-chapiters");
                    }
                    get IsVisible() {
                        return this.container.hasClass("show-chapiters");
                    }
                    Show() { this.container.addClass("show-chapiters"); }
                    Hide() { this.container.removeClass("show-chapiters"); }
                }
                ChapiterInternal.RightList = RightList;
            })(ChapiterInternal = VideoPlayerInternals.ChapiterInternal || (VideoPlayerInternals.ChapiterInternal = {}));
            class ChapiterMenuToggleEventArgs {
                constructor(data) {
                    this._isPreventDefaultAction = false;
                    this.chapiterMenuVisible = data.chapiterMenuVisible;
                }
                preventDefaultAction() {
                    this._isPreventDefaultAction = true;
                }
                get isPreventDefaultAction() {
                    return this._isPreventDefaultAction;
                }
            }
        })(VideoPlayerInternals = Controls.VideoPlayerInternals || (Controls.VideoPlayerInternals = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=VideoPlayer.Chapiter.pre.js.map
